// Audience maison : sans cookie, sans localStorage, anonyme (CNIL-friendly).
// On envoie juste un évènement au backend qui calcule un hash anonyme côté serveur.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function utm() {
  try {
    const p = new URLSearchParams(window.location.search);
    return { utm_source: p.get("utm_source") || undefined, utm_campaign: p.get("utm_campaign") || undefined };
  } catch {
    return {};
  }
}

function send(body) {
  try {
    const payload = JSON.stringify({ ...body, ...utm() });
    const url = `${API}/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true }).catch(() => {});
    }
  } catch {
    /* noop */
  }
}

export function trackPageview(path) {
  send({ type: "pageview", path: path || window.location.pathname, referrer: document.referrer || undefined });
}

export function trackClick(name) {
  send({ type: "click", path: window.location.pathname, name });
}
